import IconWithFallback from "Global/IconWithFallback";
import { EXCHANGES, ICON_TYPES } from "@shared/common/constants";
import React from "react";
import Flex from "common/Boxes/Flex";
import Title from "common/Typography/Title";
import Tag from "common/Tags/Tag";
import styled, { useTheme } from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc";
import { BOTTOM_NAVIGATOR } from "common/constants";

interface ExchangeCardProps {
  primaryExchange: string;
  tags?: string[];
  onSelectExchange?: (primaryExchange: string) => void;
}

const ExchangeCard = ({
  primaryExchange,
  tags,
  onSelectExchange,
}: ExchangeCardProps) => {
  const theme = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  return (
    <Card
      onClick={() => onSelectExchange?.(primaryExchange)}
      $hideHover={isBottomNavigator}
    >
      <Flex style={{ justifyContent: "flex-start" }}>
        <IconWithFallback
          iconType={ICON_TYPES.EXCHANGE}
          coinOrExchangeName={primaryExchange}
          iconStyle={{
            width: ICON_SIZE,
            height: ICON_SIZE,
            marginRight: 16,
            filter:
              primaryExchange === EXCHANGES.OKX && theme.isDarkMode
                ? `invert(1)`
                : undefined,
          }}
        />
        <div>
          <Exchange>{primaryExchange}</Exchange>
          <TagsWrapper>
            {tags?.map((type, index) => (
              <Tag
                key={index}
                color={theme.colors.secondaryGrey}
                bgColor={
                  theme.isDarkMode
                    ? theme.colors.tagBgColor
                    : theme.colors.statisticsBgColor
                }
                style={{ whiteSpace: "nowrap" }}
              >
                {type}
              </Tag>
            ))}
          </TagsWrapper>
        </div>
      </Flex>
    </Card>
  );
};

export default ExchangeCard;

const ICON_SIZE = 32;

const Card = styled.div<{ $hideHover?: boolean }>`
  padding: 12px 16px;
  border: ${(p) => p.theme.borders.light};
  border-radius: 12px;
  cursor: pointer;
  height: fit-content;
  &:hover {
    @media (min-width: ${BOTTOM_NAVIGATOR}) {
      border-color: ${(p) => p.theme.colors.primaryBlue};
    }
  }
  transition: border-color 0.4s ease-in-out;
`;
const Exchange = styled(Title).attrs({ level: 4 })`
  margin-bottom: 4px;
`;
const TagsWrapper = styled(Flex)`
  column-gap: 4px;
  justify-content: flex-start;
`;
